import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { EndpointParams, FeeCenter } from '@models/index';
import { HttpService } from '@services/index';

@Injectable()
export class FeeCenterService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    search(idFee: string): Observable<FeeCenter[]> {
        return this.get(`fee/center/member/${idFee}`, this.defaultEndpointParams);
    }

    searchPublic(idFee: string, publicToken: string): Observable<FeeCenter[]> {
        const params = new HttpParams({ fromString: `centerToken=${publicToken}` });

        return this.get(`fee/center/public/${idFee}`, this.defaultEndpointParams, params);
    }
}
